import React, { Suspense, useEffect, useState } from 'react';
import styles from 'index.module.css';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import 'i18n';

import { useScrollPosition } from 'hooks/localStorage.hooks';
import { Preloader } from 'components/preloader/Preloader';
import { Header } from 'components/header/Header';
import { Hero } from 'sections/heroPage/hero/Hero';
import { Advantages } from 'sections/heroPage/advantages/Advantages';
import { Popup } from 'components/popup/Popup';
import { Footer } from 'components/footer/Footer';
import { HeroShowsLazy } from 'sections/heroPage/heroShows/HeroShowsLazy';
import { PremiumOfferingLazy } from 'sections/heroPage/premiumOfferings/PremiumOfferingLazy';
import { GalleryLazy } from 'sections/heroPage/gallery/GalleryLazy';
import { RequestsLazy } from 'sections/heroPage/requests/RequestsLazy';
import { ContactFormBookEventLazy } from 'components/contactFormBookEvent/ContactFormBookEventLazy';
import { ENG_URL } from 'constants/navigation';
import { EN_LANG, FR_LANG } from 'components/langSwitcher/constants';
import LinearLoader from 'components/linearLoader/LinearLoader';

function App(): React.JSX.Element {
    const [isVideoLoaded, setIsVideoLoaded] = useState(false);
    useScrollPosition();

    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const { i18n } = useTranslation();
    const location = useLocation();

    useEffect(() => {
        if (location.pathname.startsWith(ENG_URL)) {
            i18n.changeLanguage(EN_LANG);
        } else {
            i18n.changeLanguage(FR_LANG);
        }
    }, [location.pathname, i18n]);

    const openClosePopup = () => {
        setIsPopupOpen(!isPopupOpen);
    };

    return (
        <Suspense fallback={<LinearLoader />}>
            <main className={styles.app}>
                <Preloader
                    isVideoLoaded={isVideoLoaded}
                    setIsVideoLoaded={setIsVideoLoaded}
                >
                    <>
                        <Header openClosePopup={openClosePopup} />
                        <Hero openClosePopup={openClosePopup} />
                    </>
                </Preloader>
                <Advantages />
                <HeroShowsLazy />
                <PremiumOfferingLazy />
                <GalleryLazy />
                <RequestsLazy />

                <Footer />

                <Popup isOpen={isPopupOpen} onClose={openClosePopup}>
                    <ContactFormBookEventLazy onClose={openClosePopup} />
                </Popup>
            </main>
        </Suspense>
    );
}

export default App;
